import React from 'react';
import { Button, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { isAccountPage } from 'helpers';
import { useSelector, useDispatch } from 'react-redux';
import { setHeader } from 'actions/headerAction';
import styled from 'styled-components';
import { history } from 'store/configureStore';
import { Hub, Auth } from 'aws-amplify';
import { consoleLogger } from 'helpers';

/**
 * 認証済みヘッダー
 */
const AuthedHeader = () => {
  const headerState = useSelector(state => state.header);
  const dispatch = useDispatch();
  React.useEffect(() => {
    // ログイン前画面から来た場合
    if (history.location.state && history.location.state.fromPrelogin) {
      checkCurrentSession();
    }
    // サインインボタンが押下されたときのイベントを検出する
    Hub.listen('auth', async () => {
      checkCurrentSession();
    });
  }, []);

  const checkCurrentSession = async () => {
    try {
      const currentSession = await Auth.currentSession();
      if (currentSession !== undefined && currentSession !== null) {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        dispatch(setHeader(cognitoUser.attributes.email));
        // スタートページの場合はリダイレクト
        if (history.location.pathname === '/start') {
          history.replace('/srv/files');
        } 
      }
    } catch (err) {
      consoleLogger('token error', err);
      if (history.location.pathname !== '/start') {
        history.replace('/start');
      }
    }
  };

  /**
   * Sign out
   */
  const signOut = async () => {
    await Auth.signOut({gobal: true}).then(() => {
      history.replace('/logout');
    });
  };

  return (
    <StyledNavbar bg="dark" expand="lg" className="navbar-dark " >
      <div className="navbar-brand">
        <div id="nav-logo">OTA Server</div>
      </div>
      {/* 管理者アカウント＋プログラムファイル両方可能 */}
      <Nav className="mr-auto">
        <NavDropdown className="activeMenu" title={ isAccountPage() ? 'Admin list' : 'Program files'}>
          {headerState && headerState.isAccount &&
            <NavDropdown.Item as={Link} to="/adm/accounts">Admin list</NavDropdown.Item>}
          {headerState && headerState.isProgram &&
            <NavDropdown.Item as={Link} to="/srv/files">Program files</NavDropdown.Item>}
        </NavDropdown>
      </Nav>
      <Nav>
        {headerState && 
        <NavDropdown title={headerState && headerState.mail ? headerState.mail : ''} className="dropdown-menu-right mailbox activeMail">
          <NavDropdown.Item onClick={signOut}>Sign out</NavDropdown.Item>
        </NavDropdown>}
        {!headerState && 
          <Button className="p-0 text-white" variant="link" onClick={signOut}>Sign out</Button>
        }
      </Nav>
    </StyledNavbar>
  );
};


// プルダウンの文字色を白にする
export const StyledNavbar = styled(Navbar)`
  &.navbar-dark .navbar-nav .nav-link{
    color: #fff;
  }

  /* メール欄最小幅 */
  .mailbox {
    min-width: 160px;
  }
`;

export default AuthedHeader;
